import { Configuration, PopupRequest } from "@azure/msal-browser";

//create constant object for the policies

// https://learn.microsoft.com/en-us/azure/active-directory-b2c/configure-authentication-sample-react-spa-app
export const b2cPolicies = {
  names: {
    signUpSignIn: "b2c_1_signin_signup",
    signUp: "B2C_1_signup",
    resetPassword: "b2c_1_reset",
    editProfile: "b2c_1_edit_profile",
  },
  rootAuthority:
    "https://agentsintel.ciamlogin.com/agentsintel.onmicrosoft.com",
};
export const msalConfig: Configuration = {
  auth: {
    clientId: "f5dd406d-f9a4-46b6-b7b3-b27a79df7596",
    authority: b2cPolicies.rootAuthority,
    knownAuthorities: [
      "agentsintel.ciamlogin.com",
      "agentsintel.onmicrosoft.com",
    ],
    redirectUri: "/",
    postLogoutRedirectUri: "/logged-out",
    // navigateToLoginRequestUrl: true,
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["api://AgentsIntel-api/access_as_user"],
};

// Login request that forces re-authentication (use after logout)
export const loginRequestWithPrompt: PopupRequest = {
  scopes: ["api://AgentsIntel-api/access_as_user"],
  prompt: "login",
};
